import { render, staticRenderFns } from "./ChevronRight.vue?vue&type=template&id=63abee64&"
import script from "./ChevronRight.vue?vue&type=script&lang=js&"
export * from "./ChevronRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports